export default "__VITE_ASSET__WZQqnA2m__"